import React from "react";

function Announcements_Home() {
  return (
        <div className="box announcements-box">
      <h1 className="heading">Announcements</h1>
      <div className="bullet-text">
        <div className="bullet-item">
          <span className="bold-text">
            Selection List for PhD Program
          </span>{" "}
          July 2026 session is out <br />
          Click{" "}
          <a href="https://drive.google.com/file/d/13u7Mmvr6Lgpe8iLAVjq6wh4pPUEVD8jf/view?usp=drive_link">
            here
          </a>{" "}
          to view.
        </div>
      </div>
    </div>
  );
}

export default Announcements_Home;
